import * as React from 'react';
import { useColorScheme } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PaletteIcon from '@mui/icons-material/Palette';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import { useGlobalContext } from '../contexts/GlobalContext';

const ColorModeIconDropdown = props => {
  const { mode, setMode } = useColorScheme();
  const { themeMode, setThemeMode } = useGlobalContext();

  // Effect to sync MUI color scheme with global context
  React.useEffect(() => {
    if (themeMode && themeMode !== mode) {
      setMode(themeMode);
    }
  }, [themeMode, mode, setMode]);

  if (!mode) {
    return null;
  }

  const handleModeChange = event => {
    const newMode = event.target.value;
    setMode(newMode);
    setThemeMode(newMode);
  };

  const getThemeIcon = themeMode => {
    switch (themeMode) {
      case 'light':
        return <LightModeIcon fontSize="small" />;
      case 'dark':
        return <DarkModeIcon fontSize="small" />;
      case 'system':
        return <SettingsBrightnessIcon fontSize="small" />;
      default:
        return <PaletteIcon fontSize="small" />;
    }
  };

  return (
    <Select
      value={mode}
      onChange={handleModeChange}
      renderValue={selected => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {getThemeIcon(selected)}
          {selected.charAt(0).toUpperCase() + selected.slice(1)}
        </div>
      )}
      SelectDisplayProps={{
        // @ts-ignore
        'data-screenshot': 'toggle-mode',
      }}
      {...props}
    >
      <MenuItem value="system">
        <ListItemIcon>
          <SettingsBrightnessIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>System</ListItemText>
      </MenuItem>
      <MenuItem value="light">
        <ListItemIcon>
          <LightModeIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Light</ListItemText>
      </MenuItem>
      <MenuItem value="dark">
        <ListItemIcon>
          <DarkModeIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Dark</ListItemText>
      </MenuItem>
    </Select>
  );
};

export default ColorModeIconDropdown;
